import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Clock, AlertCircle } from 'lucide-react';
export function DeadlineScarcity() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-b from-black via-red-950/20 to-black overflow-hidden" data-id="element-626">
      <motion.div ref={ref} initial={{
      opacity: 0,
      scale: 0.95
    }} animate={inView ? {
      opacity: 1,
      scale: 1
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto text-center" data-id="element-627">
        <div className="inline-block p-4 sm:p-6 rounded-full bg-red-900/20 border border-red-500/50 mb-6 sm:mb-8" data-id="element-628">
          <Clock className="w-10 h-10 sm:w-12 sm:h-12 text-red-500 animate-pulse" data-id="element-629" />
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-stone-100 mb-6 sm:mb-8" style={{
        fontFamily: 'Cinzel, serif'
      }} data-id="element-630">
          The Clock Is Ticking
        </h2>

        <p className="text-lg sm:text-xl md:text-2xl text-stone-300 mb-8 sm:mb-12 max-w-2xl mx-auto" data-id="element-631">
          This opportunity vanishes on{' '}
          <span className="text-red-500 font-bold" data-id="element-632">
            Friday, April 3rd at 11:59 PM ET
          </span>
          .
        </p>

        <div className="bg-red-950/30 border-2 border-red-500/50 p-6 sm:p-8 rounded-lg max-w-3xl mx-auto mb-10 sm:mb-12" data-id="element-633">
          <div className="flex items-start gap-4 text-left" data-id="element-634">
            <AlertCircle className="w-6 h-6 sm:w-8 sm:h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-635" />
            <div data-id="element-636">
              <p className="text-lg sm:text-xl font-bold text-red-400 mb-2" data-id="element-637">
                Warning:
              </p>
              <p className="text-stone-300 text-base sm:text-lg" data-id="element-638">
                Once the deadline passes, this pricing will be gone forever. We
                may reopen enrollment in the future, but the price will be
                significantly higher.
              </p>
            </div>
          </div>
        </div>

        <button onClick={() => {
        const pricingSection = document.querySelector('[data-pricing-section]');
        if (pricingSection) {
          pricingSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }} className="inline-block px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-black font-bold text-lg sm:text-xl rounded-lg shadow-[0_0_30px_rgba(217,119,6,0.4)] hover:shadow-[0_0_50px_rgba(217,119,6,0.6)] hover:scale-105 transition-all duration-300 min-h-[44px]" data-id="element-639">
          Join the Private Research Order Now
        </button>
      </motion.div>
    </section>;
}